import { useMemo, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { getFormattedValueFromDateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { ReportFilter, ReportParam } from './types';

export const useFilterParam = (
  filter: ReportFilter,
  initialized: boolean,
): ReportParam | undefined => {
  const [startDate, endDate] = useMemo(
    () => getFormattedValueFromDateRange(filter.range),
    [filter.range],
  );
  const validFilters = useMemo(
    () => filter.criteria.filter(FieldFilter.isValid),
    [filter],
  );
  const [filterParam, setFilterParam] = useState<ReportParam>();

  useDeepCompareEffect(() => {
    if (!initialized) {
      return;
    }
    setFilterParam({
      startDate,
      endDate,
      validFilters,
      match: filter.type,
    });
  }, [startDate, endDate, validFilters, filter.type, initialized]);

  return filterParam;
};
